export default {
	vipBenefits: {
		salaryTitle: 'VIP تنخواہ',
		benefitsTitle: 'فوائد',
		yourVipProgress: 'آپ کی VIP پیشرفت',
		progressToVip: 'VIP {level} تک {percent}%',
		vipMax: 'زیادہ سے زیادہ سطح حاصل',
		vipLevelBenefits: 'VIP سطح اور فوائد',
		betXpRule: 'شرط {amount} = {xp}EXP',
		btnReceive: 'وصول کریں',
		btnJoinIn: 'شامل ہوں',
		btnReceived: 'وصول ہو گیا',
		btnExpired: 'ختم ہو گیا',
		btnNotSettled: 'طے نہیں ہوا',
		btnComingSoon: 'جلد آ رہا ہے',
		btnViewMore: 'مزید دیکھیں',
		btnContactNow: 'رابطہ کریں',
		guestTitleLevelup: 'لیول اپ بونس',
		guestTitleDaily: 'روزانہ تنخواہ',
		guestTitleWeekly: 'ہفتہ وار تنخواہ',
		guestTitleMonthly: 'ماہانہ تنخواہ',
		guestTitleCashback: 'کیش بیک',
		guestTitleRescue: 'ریسکیو بونس',
		guestTitleEvents: 'VIP ایونٹس',
		guestTitleSupport: 'VIP سپورٹ',
		guestDescLevelup: 'ہر بار نئے VIP لیول تک پہنچنے پر یک بار بونس حاصل کریں۔',
		guestDescDaily: 'آپ کا VIP لیول بڑھنے پر روزانہ تنخواہ انعام حاصل کریں۔',
		guestDescWeekly: 'آپ کا VIP لیول بڑھنے پر ہفتہ وار تنخواہ انعام حاصل کریں۔',
		guestDescMonthly: 'آپ کا VIP لیول بڑھنے پر ماہانہ تنخواہ انعام حاصل کریں۔',
		guestDescCashback: 'اپنے گیم اخراجات پر کیش بیک کمائیں۔',
		guestDescRescue: 'واپسی میں مدد کے لیے ریسکیو بونس حاصل کریں۔',
		guestDescEvents: 'اعلیٰ VIP لیول مزید خصوصی ایونٹ انعامات کھولتے ہیں۔',
		guestDescSupport: 'تیز تر مدد کے لیے مخصوص VIP سپورٹ۔',
		comingSoonHint: 'فائدہ جلد آ رہا ہے، منتظر رہیں',
		receiveSuccess: 'انعام وصول ہو گیا',
		receiveFailed: 'انعام وصول کرنے میں ناکامی',
		typeUpgrade: 'لیول اپ بونس',
		typeDailySalary: 'روزانہ تنخواہ',
		typeWeeklySalary: 'ہفتہ وار تنخواہ',
		typeMonthlySalary: 'ماہانہ تنخواہ',
		typeRebate: 'کیش بیک',
		typeRescue: 'ریسکیو بونس',
		typeVipActivity: 'VIP ایونٹس',
		typeVipService: 'VIP سپورٹ',
		tooltipRecharge: 'ریچارج {current}/{target}',
		tooltipBets: 'شرطیں {current}/{target}',
		progressRecharge: 'ریچارج',
		progressBets: 'شرطیں',
		descUpgradeBonus: 'VIP{level} اپ گریڈ بونس ×{count}',
		descDailySalary: 'VIP{level} روزانہ تنخواہ ×{count}',
		descWeeklySalary: 'VIP{level} ہفتہ وار تنخواہ ×{count}',
		descMonthlySalary: 'VIP{level} ماہانہ تنخواہ ×{count}',
		descUpgradeBonusPlain: 'VIP{level} اپ گریڈ بونس',
		descDailySalaryPlain: 'VIP{level} روزانہ تنخواہ',
		descWeeklySalaryPlain: 'VIP{level} ہفتہ وار تنخواہ',
		descMonthlySalaryPlain: 'VIP{level} ماہانہ تنخواہ',
		descRebate: 'VIP{level} گیم کیش بیک',
		descRescue: 'VIP{level} ریسکیو بونس',
		descVipActivity: 'اعلیٰ VIP لیول مزید خصوصی ایونٹ انعامات کھولتے ہیں۔',
		descVipService: 'تیز تر مدد کے لیے مخصوص VIP سپورٹ۔',
		allBenefits: 'تمام فوائد',
		vipClubTitle: 'VIP Club',
		more: 'مزید',
		moreDesc: 'مزید تفصیلات کے لیے براہ کرم ہماری پروموشنز دیکھیں۔',
		promotions: 'پروموشنز',
		highlightsTitle: '8 خصوصی خصوصیات',
		highlightSupport: 'خصوصی VIP سپورٹ',
		highlightLevelup: 'لیول اپ بونس',
		highlightSalary: 'VIP تنخواہ',
		highlightRescue: 'VIP ریسکیو بونس',
		highlightGifts: 'خصوصی\nVIP تحائف',
		highlightEvents: 'VIP ایونٹس',
		highlightService: 'مخصوص\nVIP سروس',
		highlightWallet: 'VIP\nکریڈٹ والیٹ',
		currentLevel: 'موجودہ سطح',
		keepPlayingReach: 'پہنچنے کے لیے کھیلتے رہیں',
		higherLevelRewards: 'جتنی اونچی سطح، اتنے زیادہ انعامات',
		levelUpUnlock: 'خصوصی مراعات انلاک کرنے اور پریمیم تجربے سے لطف اندوز ہونے کے لیے اپنی سطح بڑھائیں۔',
		yourVipBenefits: 'آپ کے VIP فوائد',
		viewVipLevels: 'VIP سطحیں دیکھیں',
		exclusiveBenefitsTitle: 'آپ کے خصوصی فوائد',
		tipExclusiveRewards: 'خصوصی انعامات',
		tipHigherRakeback: 'زیادہ ری بیٹ',
		tipPrioritySupport: 'ترجیحی سپورٹ',
		levelGroupBronze: 'Bronze',
		levelGroupBrass: 'Brass',
		tableLevel: 'لیول',
		tableRequiredXp: 'مطلوبہ EXP',
		tableLevelUpBonus: 'لیول اپ بونس',
		tableDailyRakeback: 'روزانہ ری بیٹ',
		tableWeeklyLossback: 'ہفتہ وار نقصان واپسی',
		signIn: 'سائن ان',
		vipClubDefaultDesc: 'ابھی ہمارے VIP Club میں شامل ہوں اور تحائف، انعامات اور شاندار فیچرز حاصل کرنے کے لیے تیار ہو جائیں۔',
	},
};
